document.addEventListener('DOMContentLoaded', () => {
  const plpAtcs = document.querySelectorAll('.plp-atc-btn.plp-atc-addbtn')
  plpAtcs.forEach((atc) => {
    atc.addEventListener('click', function (event) {
      event.preventDefault()
      atc.dataset.loading = null
      if (atc.dataset.productVariantId) {
        const addToCartPayload = {
          quantity: 1,
          id: atc.dataset.productVariantId,
        }

        if (atc.dataset.sellingPlanId) addToCartPayload.selling_plan = atc.dataset.sellingPlanId
        if (atc.dataset.backorderMessage) addToCartPayload.properties = { Backorder: atc.dataset.backorderMessage }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(addToCartPayload),
        }).then((response) => {
          delete atc.dataset.loading
          window.HybridCart.open()
        })
      }
    })
  })
})
